// assets/collection-ajax-add.js
(function () {
  function getQty(form) {
    const el =
      form.querySelector('[data-quantity-input]') ||
      form.querySelector('[name="quantity"]');
    const qty = el ? parseInt(el.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function setButtonLoading(btn, isLoading) {
     if (!btn) return;

    const textEl = btn.querySelector("[data-add-to-cart-text]");
    const loaderEl = btn.querySelector("[data-loader]");

    btn.disabled = !!isLoading;
    btn.setAttribute("aria-busy", isLoading ? "true" : "false");

    if (textEl) textEl.classList.toggle("hide", !!isLoading);
    if (loaderEl) loaderEl.classList.toggle("hide", !isLoading);
  }

  async function updateCartIconCount() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();
    const count = cart.item_count || 0;

    // Update common cart count nodes
    const nodes = document.querySelectorAll(
      "[data-cart-count], #cart-icon-bubble [aria-hidden], .cart-count-bubble span[aria-hidden], .cart-count-bubble__text"
    );

    nodes.forEach((n) => {
      if (!n) return;
      // Update only numeric counters
      if (n.matches("[data-cart-count]") || n.getAttribute("aria-hidden") === "true") {
        n.textContent = String(count);
      }
    });

    document.querySelectorAll(".cart-count-bubble").forEach((b) => {
      b.style.display = count > 0 ? "" : "none";
    });
  }

  async function addToCart(form) {
    const idEl = form.querySelector('input[name="id"]');
    const variantId = idEl ? idEl.value : null;
    const quantity = getQty(form);
    if (!variantId) return;

    const btn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector("[data-add-to-cart]");

    try {
      setButtonLoading(btn, true);

      // ✅ IMPORTANT: include properties[_moq], properties[_inc], selling_plan, etc.
      const fd = new FormData(form);

      // Ensure required fields exist / are correct
      fd.set("id", variantId);
      fd.set("quantity", String(quantity));

      const resp = await fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      setButtonLoading(btn, false);

      if (!resp.ok) return;

      await updateCartIconCount();
    } catch (e) {
      setButtonLoading(btn, false);
    }
  }


  // ✅ Capture click on the Add to cart button before theme JS sees it
  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest('form.js-collection-ajax-add button[type="submit"], form.js-collection-ajax-add [data-add-to-cart]');
      if (!btn) return;

      const form = btn.closest("form.js-collection-ajax-add");
      if (!form) return;

      // Stop theme handlers from submitting / sending their own AJAX
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      addToCart(form);
    },
    true // ✅ capture
  );

  // ✅ Also block native submit just in case (belt & suspenders)
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form || !form.classList || !form.classList.contains("js-collection-ajax-add")) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
    },
    true
  );
})();
